import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import PropTypes from 'prop-types';
import styles from './styles.less';

const propsByVersion = {
  default: {
    className: styles.default,
  },
};

const DatePicker = ({ version, className, ...rest }) => {
  const { className: propsClassName = '', ...props } = propsByVersion[version];

  return <AntDatePicker {...props} className={`${propsClassName} ${className}`} {...rest} />;
};

DatePicker.propTypes = {
  version: PropTypes.oneOf(['default']),
  className: PropTypes.string,
};

DatePicker.defaultProps = {
  version: 'default',
  className: '',
};

export default DatePicker;
